import { createContext, useContext, useState } from 'react';

const MemberExpandedContext = createContext({ isExpanded: false, setIsExpanded: () => {} });

export function MemberExpandedProvider({ children }) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <MemberExpandedContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </MemberExpandedContext.Provider>
  );
}

export function useMemberExpanded() {
  return useContext(MemberExpandedContext);
}
